// src/components/devices/SmartLockCard.js
import React, { useState } from 'react';
import './SmartLockCard.css';

/**
 * Component to display a smart lock card with basic controls
 */
const SmartLockCard = ({ lock, onToggle, onDetails }) => {
  const [isLoading, setIsLoading] = useState(false);
  
  // Handle lock toggle
  const handleToggle = async () => {
    try {
      setIsLoading(true);
      await onToggle(lock.lockMac, lock.isLocked);
    } catch (error) {
      console.error('Error toggling lock:', error);
    } finally {
      setIsLoading(false);
    }
  };
  
  // Handle details click
  const handleDetails = () => {
    if (onDetails) {
      onDetails(lock);
    }
  };
  
  // Determine status class
  const getStatusClass = () => {
    if (!lock.isConnected) return 'status-disconnected';
    return lock.isLocked ? 'status-locked' : 'status-unlocked';
  };
  
  // Determine battery class
  const getBatteryClass = () => {
    if (!lock.batteryLevel) return 'battery-unknown';
    if (lock.batteryLevel < 20) return 'battery-critical';
    if (lock.batteryLevel < 50) return 'battery-low';
    return 'battery-good';
  };

  return (
    <div className={`smart-lock-card ${getStatusClass()}`}>
      <div className="smart-lock-header">
        <h3>{lock.lockAlias || `Lock (${lock.lockMac})`}</h3>
        <div className={`battery-indicator ${getBatteryClass()}`}>
          {lock.batteryLevel ? `${lock.batteryLevel}%` : 'Unknown'}
        </div>
      </div>
      
      <div className="smart-lock-status">
        <div className="status-indicator">
          <div className={`status-dot ${getStatusClass()}`}></div>
          <span>
            {!lock.isConnected ? 'Disconnected' : (lock.isLocked ? 'Locked' : 'Unlocked')}
          </span>
        </div>
      </div>
      
      <div className="smart-lock-controls">
        <button 
          className={`toggle-button ${lock.isLocked ? 'unlock' : 'lock'}`} 
          onClick={handleToggle}
          disabled={!lock.isConnected || isLoading}
        >
          {isLoading ? 'Processing...' : (lock.isLocked ? 'Unlock' : 'Lock')}
        </button>
        
        <button 
          className="details-button"
          onClick={handleDetails}
        >
          Details
        </button>
      </div>
    </div>
  );
};

export default SmartLockCard;